import React, { useEffect, useRef } from 'react';
import flvjs from 'flv.js';
const FlvPlayer = (props) => {
    const { className, style, controls = true, autoplay = true, config, url, type = 'flv', cors, isLive, withCredentials, hasAudio, hasVideo, duration, filesize, } = props;
    const flvPlayer = useRef();
    const videoElement = useRef();
    useEffect(() => {
        if (videoElement.current && flvjs.isSupported()) {
            flvPlayer.current = flvjs.createPlayer({ url, type, cors, isLive, withCredentials, hasAudio, hasVideo, duration, filesize }, config);
            flvPlayer.current.attachMediaElement(videoElement.current);
            flvPlayer.current.load();
            if (autoplay) {
                flvPlayer.current.play();
            }
        }
        return () => {
            flvPlayer.current.unload();
            flvPlayer.current.detachMediaElement();
            flvPlayer.current.destroy();
        };
    }, [autoplay, config, cors, duration, filesize, hasAudio, hasVideo, isLive, type, url, withCredentials]);
    return (<video className={className} controls={controls} style={Object.assign({
            width: '100%',
        }, style)} ref={videoElement}/>);
};
export default FlvPlayer;
